export default {
  title: 'Imports'
}
